// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import constant from './constants'
import store from './store'
import i18n from './lang.js'
import Mixin from './mixins/index.js'
import disposition from './plugins/disposition.js'
import VModal from 'vue-js-modal'
import * as uiv from 'uiv'

/*import HomeFooter from './components/home/HomeFooterJP.vue'
import HomeTop from './components/home/HomeTop.vue'
import MainLayout from './layouts/Main.vue'
import HomeLayout from './layouts/Home.vue'
import HomeLandingLayout from './layouts/HomeLanding.vue'
import SimpleLayout from './layouts/Simple.vue'
import ComboLayout from './layouts/Combo.vue'*/
import VueSession from 'vue-session'
import VueMoment from 'vue-moment'
import axios from './axios.js'
import VueAxios from 'vue-axios'
import cart from './plugins/cart.js'
import Notifications from 'vue-notification'
import VueAuth from '@websanova/vue-auth'
import Nl2br from 'vue-nl2br'
import ErrorHandler from './plugins/ErrorHandler'
import WarnHandler from './plugins/WarnHandler'
import VueCookie from 'vue-cookie'
import VueAnalytics from 'vue-analytics'
import '@pizza-hut/fcds-ui'
import _ from 'lodash'

Vue.router = router
Vue.use(VueAxios, axios)
Vue.axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.axios.defaults.headers.common['Client'] = '606dd890-1e5d-4898-853a-0ef434fff627'
Vue.axios.defaults.headers.common['Lang'] = 'ja'
Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      let info = JSON.parse(unescape(atob(token)))
      this.options.http._setHeaders.call(this, req, {'x-token': info.token})
    },

    response: function (res) {
      if (typeof res.data.data !== 'undefined' && res.data.data != null) {
        if (typeof res.data.data.item !== 'undefined' && res.data.data.item != null && res.data.data.item.token) {
          let info = res.data.data.item
          return btoa(escape(JSON.stringify(info)))
        }
      }
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  refreshData: {enabled: false},
  loginData: {
    url: process.env.version + '/product-customer/fe-login',
    method: 'POST',
    redirect: true,
    fetchUser: false
  },
  fetchData: {
    enabled: false,
    success: function () {
      let info = Vue.auth.token()

      if (info) {
        info = JSON.parse(unescape(atob(info)))
      }
      Vue.auth.user(info)
    }
  },
  logoutData: {
    url: process.env.version + '/product-customer/logout',
    method: 'POST',
    redirect: false,
    makeRequest: true
  },
  notFoundRedirect: {
    path: '/',
  },
  forbiddenRedirect: {
    path: '/error-404'
  },
  authRedirect: {
    enabled: false
  }
})

Vue.component('async-component', function (resolve) {
  require([
    '@/components/popup/ModalPizza.vue',
    '@/components/popup/ModalPizzaHalf.vue'
  ], resolve)
});

const options = {name: 'lodash'}
Vue.config.productionTip = false
Vue.config.performance = true
Vue.config.devtools = false
//Vue.config.errorHandler = (err, vm, info) => ErrorHandler.write(err, vm, info)
//Vue.config.warnHandler = (msg, vm, trace)  => WarnHandler(msg, vm, trace)
Vue.prototype.$const = constant
Vue.prototype._ = _

Vue.mixin(Mixin)
Vue.use(disposition)
Vue.use(VueSession, {persist: true})
Vue.use(VueCookie)
Vue.use(cart)
Vue.use(uiv)
Vue.use(Notifications)
Vue.use(VModal, {dynamic: true, injectModalsContainer: true, dialog: true})
Vue.use(VueAnalytics, {
  id: process.env.GA_KEY,
  checkDuplicatedScript: true
})

/* Component Layouts */
Vue.component('main-layout', function (resolve) {
  require(['./layouts/Main.vue'], resolve)
});
Vue.component('home-layout', function (resolve) {
  require(['./layouts/Home.vue'], resolve)
});
Vue.component('simple-layout', function (resolve) {
  require(['./layouts/Simple.vue'], resolve)
});
Vue.component('error-page-layout', function (resolve) {
  require(['./layouts/ErrorPage.vue'], resolve)
});
Vue.component('combo-layout', function (resolve) {
  require(['./layouts/Combo.vue'], resolve)
});
Vue.component('home-landing-layout', function (resolve) {
  require(['./layouts/HomeLanding.vue'], resolve)
});
Vue.component('home-footer', function (resolve) {
  require(['./components/home/HomeFooterJP.vue'], resolve)
});
Vue.component('home-top', function (resolve) {
  require(['./components/home/HomeTop.vue'], resolve)
});
Vue.component('modal-notify', function (resolve) {
  require(['./components/popup/ModalNotify.vue'], resolve)
});

Vue.component('modal-notify-message', function (resolve) {
  require(['./components/popup/ModalNotifyMessage.vue'], resolve)
});

Vue.component('nl2br', Nl2br)
/*Vue.component('main-layout', MainLayout)
Vue.component('home-layout', HomeLayout)
Vue.component('simple-layout', SimpleLayout)
Vue.component('combo-layout', ComboLayout)
Vue.component('home-landing-layout', HomeLandingLayout)
Vue.component('nl2br', Nl2br)
Vue.component('home-footer', HomeFooter)
Vue.component('home-top', HomeTop)*/

/* Vue moment */
Vue.use(VueMoment)
// Vue event bus
const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

/* eslint-disable no-new */
const main = new Vue({
  el: '#app',
  i18n,
  store,
  router,
  template: '<App/>',
  components: {App},
  mounted() {
    this.$cart.init(this)
    this.loadPage()
    document.dispatchEvent(new Event('render-event'))
  },
  created: function () {
    // change langues
    this.$session.set('client', '606dd890-1e5d-4898-853a-0ef434fff627')
    this.$session.set('google-key-api', 'AIzaSyDKYCZ1DFNXUqDlouh_gmdpCcd05JOxp8Q')
    if (!this.$session.get('lang')) {
      this.$session.set('lang', this.$i18n.locale)
    }
    this.$i18n.locale = this.$session.get('lang') || this.$i18n.locale
    if (!this.$session.get('lang')) {
      this.$session.set('lang', this.$i18n.locale)
    }
    Vue.axios.defaults.headers.common['Lang'] = this.$i18n.locale
  },
  methods: {
    loadPage() {
      this.$cart.getDetail(this)
    }
  }
})
export default main



// WEBPACK FOOTER //
// ./src/main.js